import useSWR, { type SWRConfiguration } from 'swr';

import { getUserById, type GetUserByIdResponse } from '@services/UsersService';

export type UseGetUserByIdParams = {
  queryParams: {
    userId: string | null;
  };
  swrOptions?: SWRConfiguration<GetUserByIdResponse, unknown>;
};

export const getUserByIdQueryKey = (userId: string) =>
  `get-user-by-id-${userId}`;

export const useGetUserById = ({
  queryParams: { userId },
  swrOptions,
}: UseGetUserByIdParams) => {
  const resolvedUserId = typeof userId === 'string' ? userId : null;
  const swrKey =
    resolvedUserId !== null ? getUserByIdQueryKey(resolvedUserId) : null;
  const fetchUserById =
    resolvedUserId !== null
      ? () => getUserById({ userId: resolvedUserId })
      : null;

  const { data, ...swrResponse } = useSWR<GetUserByIdResponse>(
    swrKey,
    fetchUserById,
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
